<div class="o-c">
  <div>
    <div class="card" style="margin:10px">
      <ion-grid style="padding:10px">
        <ion-row>
          <p class="a-o-i">Enter verification code</p>
        </ion-row>
        <ion-row>
          <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
          <ion-row>
            @if (invalidOTP) {
              <ion-col style="color: #e03b3b;font-size: 14px;">Invalid OTP</ion-col>
            }
          </ion-row>
        </ion-row>
        <ion-row>
          <ion-col style="color: #e03b3b;"> Didn't get code?
            @if (isCounter) {
              <span style="color: #008ed0;" (click)="reSendOTP()">Request again.</span>
            }
            @if (!isCounter) {
              <countdown style="color: #008ed0;" #countdown [config]="configTimer"
              (event)="handleEvent($event)"></countdown>
            }</ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="text-align: center;">
                      <ion-button (click)="submitOTP()" [disabled]="!isvalid" style="--background: #e35655 !important;
                      text-transform: initial;
                      border-radius:0px;
                      color: white;"> Submit OTP</ion-button>
                      <ion-button (click)="onNoClick()"  style="--background: #e35655 !important;
                      text-transform: initial;
                      border-radius:0px;
                      color: white;"> Close</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>